import { Compass } from "lucide-react";

export const REGIONS = {
  national: { center: [-96, 38.5], dist: 24, label: "National" },
  northeast: { center: [-73.4, 42.2], dist: 9, label: "Northeast" },
  midwest: { center: [-88, 42], dist: 13, label: "Midwest" },
  west: { center: [-120, 37.6], dist: 13, label: "West Coast" },
};

const ORDER = ["national", "northeast", "midwest", "west"];

export function RegionControls({ activeRegion, onRegion }) {
  return (
    <div className="region-controls" data-testid="region-controls">
      <span className="region-icon">
        <Compass size={14} strokeWidth={1.9} />
      </span>
      {ORDER.map((key) => (
        <button
          key={key}
          className={`region-btn${activeRegion === key ? " region-btn-active" : ""}`}
          data-testid={`region-${key}`}
          onClick={() => onRegion(key)}
        >
          {REGIONS[key].label}
        </button>
      ))}
    </div>
  );
}
